import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Patent } from './../../model/PatentTypes';
import classes from './PatentCard.module.css';

export interface PatentCardProps {
  patent: Patent;
  to?: string;
  onClick?: () => void;
}

export function PatentCard({ patent, to, onClick }: PatentCardProps) {
  const { title, registrationNo, state, type, institutions, owner, submissionYear, grantingYear } = patent;

  return (
    <Paper
      className={classes.card}
      onClick={onClick}
      component={to != null ? Link : undefined}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="10px">
        <TitleCard
          title={title}
          pre={<Pill>{state?.name}</Pill>}
        />
        <Text
          c="dimmed"
          size="sm"
        >
          {owner?.name}, {type?.name}, {registrationNo}
        </Text>
        <Text
          c="dimmed"
          size="sm"
        >
          Depus {submissionYear}, Câștigat: {grantingYear ?? '-'}
        </Text>
        <Group>
          {(institutions ?? []).map(inst => (
            <Pill key={inst.id}>{inst.name}</Pill>
          ))}
        </Group>
      </Stack>
    </Paper>
  );
}
